import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "./fonts/GothamBold.ttf"
import "./fonts/GothamBook.ttf"
import "./fonts/GothamLight.ttf"
import "./fonts/GothamMedium_1.ttf"
import "./fonts/GothamMedium.ttf"

ReactDOM.render(<App />, document.getElementById("root"));


//  real code ----
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// ----